/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, arrayOf } from 'prop-types';
import { useUIDSeed } from 'react-uid';
import mbpLogger from '@module-logger/mbp';
import useStyles from 'isomorphic-style-loader/useStyles';
import style from './FourUpVariantC.module.css';
import MessageStandard from '../../../../SubComponents/Message/MessageStandard';
import universalHandleClick from '../../../../UniversalHandleClick';
import normalizeAltCopy from '../../../../../../../helpers/normalizeAltCopy';

const FourUpVariantC = ({
    data, gaConstants, salesforceResponse,
}) => {
    useStyles(style);
    const isPresentationStyle = data.presentation_style?.presentation_variant === 'heading_bottom';
    const seed = useUIDSeed();
    const defaultParams = 'auto=webp';
    if (data?.tile?.length) {
        const handleClick = universalHandleClick(salesforceResponse);
        const renderHeading = (heading) => <div className={`${style.heading} ${isPresentationStyle ? style.paddingAdjust : ''}`}>{heading}</div>;
        return (
            <div className={style.container} data-testid="fourUpVariantC">
                {
                    data?.tile?.map(({
                        image, cta = {}, message = {}, styled_button,
                    }) => (
                        <div
                            key={seed(image)}
                            className={`${style.imageWrapper} ${!cta?.link?.href && !cta?.link?.title ? style.disableClick : ''}`}
                            role="presentation"
                            onClick={() => handleClick(cta, gaConstants)}
                            data-ga-category={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-ga-action={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-ga-label={cta?.tracking_event_label || gaConstants?.tracking_event_label}

                            data-banner-item-name={cta?.tracking_event_label || gaConstants?.tracking_event_label}
                            data-banner-type={cta?.tracking_event_action || gaConstants?.tracking_event_action}
                            data-banner-group={cta?.tracking_event_category || gaConstants?.tracking_event_category}
                            data-click-id="FourUpVariantC"
                            data-click-text="FourUpVariantC"
                        >
                            {message.heading && !isPresentationStyle
                                && renderHeading(message.heading) }
                            <img className={style.image} src={`${image?.url}?${defaultParams}`} alt={normalizeAltCopy(image?.description || image.title || 'Product Image')} loading="lazy" />
                            {message.heading && isPresentationStyle
                                && renderHeading(message.heading)}
                            <div className={style.messageBlock}>
                                <MessageStandard
                                    data={{
                                        content: message.content,
                                        heading: '',
                                        sub_heading: message.sub_heading,
                                        message_position: {},
                                        styled_button,
                                        cta: {
                                            link: cta.link,
                                            theme: '',
                                            presentation: 'secondary',
                                            tracking_event_category: gaConstants.tracking_event_category,
                                            tracking_event_action: gaConstants.tracking_event_action,
                                            tracking_event_label: cta.tracking_event_label,
                                        },
                                        has_background: false,
                                    }}
                                />
                            </div>
                        </div>
                    ),
                    )
                }
            </div>
        );
    }

    return mbpLogger.logError({
        appName: process.env.npm_package_name,
        component: 'Tiles/4upStandard/FourUpVariantC/FourUpVariantC.js',
        message: 'No data available to render component',
    });
};

FourUpVariantC.propTypes = {
    data: arrayOf.isRequired,
    gaConstants: object.isRequired,
    salesforceResponse: object,
};
FourUpVariantC.defaultProps = {
    salesforceResponse: {},
};

export default FourUpVariantC;
